import React, { useEffect, useState } from 'react'
import { Ionicons, Feather } from '@expo/vector-icons'
import { Text, View, Image, Dimensions, Button, TouchableOpacity as RNTouchableOpacity, Platform, Linking } from 'react-native'
import * as Progress from 'react-native-progress'
import styles from './MyAdvanceStyles'
import theme from '../../../theme'
import { avatarPlaceholder } from '../customUtils/Constants'
import { colorFilled, colorUnfilled, MyAdvanceTheme } from '../../../themeConstants'
import { ScrollView } from 'react-native-gesture-handler'

// Usar TouchableOpacity nativo en web, del wrapper en mobile
const TouchableOpacity = Platform.OS === 'web' ? RNTouchableOpacity : RNTouchableOpacity
import {
    AdvanceAchievement,
    AdvanceExam,
    AdvanceMyPoints,
    AdvanceWatchedContent,
    MyAdvanceModel,
    MyAdvanceSingleModel,
    MyTeamAdvance,
} from './models/MyAdvanceModel'
import { Loader } from '../customUtils/Components/Loader'
import { LinealTabs, RoundedTabs } from '../customUtils/LinealTabs'
import { DateFormatter } from '../customUtils/DateFormatter'
import { FlashList } from '@shopify/flash-list'

import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { MyTeamAdvanceScreen } from './MyTeamAdvance'
import { fetchAuthSession } from 'aws-amplify/auth'
import { getConection } from '../appBar/context/HeaderContext'
import { request_get_advanced_team } from '../../services/advance.services'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { useIsMobile } from '@/redux/zustand/useDimensionStore'
import { useNavigation } from '@/hooks/useWebNavigation'

const { width } = Dimensions.get('window')

export const MyAdvance = () => {
    const [loading, setLoading] = useState<boolean>(true)
    const [myAdvance, setMyAdvance] = useState<MyAdvanceModel>(null)
    const [myTeam, setMyTeam] = useState<MyTeamAdvance>(null)
    const [tabs, setTabs] = useState([])
    const [selectedIndex, setSelectedIndex] = useState(-2)
    const [updateDate, setUpdateDate] = useState('')
    const { isConnected, hasInternet } = getConection()
    const { languageFile } = getLanguage()

    useEffect(() => {
        fetchData()
    }, [])

    const route = {
        params: {
            regions: myTeam?.regions,
            updateDate: updateDate,
        },
    }

    const fetchData = async () => {
        try {
            if (isConnected && hasInternet) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ''
                const data: MyAdvanceSingleModel = await request_get_advanced_team({ authToken })
                //const data = singleAdvance
                console.log('Advance Data:', data)
                if (!data) {
                    return setSelectedIndex(-1)
                }
                let newTabs = []
                if (data.my_advance) {
                    let advanceTab = { name: 'Mi Avance', index: 0 }
                    setMyAdvance(data.my_advance)
                    newTabs.push(advanceTab)
                }
                if (data.my_team_advance) {
                    let teamTab = { name: 'Mi Equipo', index: 1 }
                    setMyTeam(data.my_team_advance)
                    newTabs.push(teamTab)
                }

                if (newTabs.length > 0) {
                    setSelectedIndex(newTabs[0].index)
                    setTabs(newTabs)
                }

                //@Fixme validar si la fecha es invalida
                let date = DateFormatter({ date: data.date })
                setUpdateDate(date)
            }
        } catch {
            setSelectedIndex(-1)
        } finally {
            setLoading(false)
        }
    }
    const isMobile = useIsMobile()
    if (loading) {
        return <Loader />
    }

    return (
        <View
            style={{
                flex: 1,
                backgroundColor: 'white',
                flexDirection: 'column',
                width: '100%',
            }}
        >
            <View
                style={[
                    {
                        flex: 1,
                        backgroundColor: 'white',
                        flexDirection: 'column',
                        width: '100%',
                    },
                    !isMobile && { maxWidth: 1024, alignSelf: 'center', flex: undefined },
                ]}
            >
                {tabs.length > 1 && (
                    <>
                        {isMobile ? (
                            <LinealTabs
                                tabs={tabs}
                                selectedIndex={selectedIndex}
                                color={theme.colors.textSecondary}
                                colorSelected={theme.colors.colorPrimary}
                                onSelectedTab={(i) => {
                                    setSelectedIndex(i)
                                }}
                            />
                        ) : (
                            <RoundedTabs
                                tabs={tabs}
                                selectedIndex={selectedIndex}
                                colorLGStart={MyAdvanceTheme.myAdvanceGradient[0]}
                                colorLGEnd={MyAdvanceTheme.myAdvanceGradient[1]}
                                colorSelected={MyAdvanceTheme.tabsSelectedColor}
                                colorUnselected={MyAdvanceTheme.tabsUnselectedColor}
                                color={theme.colors.darkGray}
                                onSelectedTab={(index) => {
                                    setSelectedIndex(index)
                                }}
                                containerStyle={{ marginHorizontal: 12 }}
                            />
                        )}
                    </>
                )}
                {(() => {
                    switch (selectedIndex) {
                        case 0:
                            return <MyAdvanceScreen myAdvance={myAdvance} updateDate={updateDate} />
                        case 1:
                            return <MyTeamAdvanceScreen route={route} />
                        default:
                            return (
                                <View style={{ height: '100%', justifyContent: 'center' }}>
                                    <Image source={require('../../../assets/advance/noDataEvaluations.png')} style={styles.noDataEvaluations} />

                                    <Text style={[styles.noDataText, { marginTop: 8, marginBottom: 16 }]}>No hay información</Text>

                                    <TouchableOpacity
                                        style={styles.mainButton}
                                        onPress={() => {
                                            setLoading(true)
                                            setSelectedIndex(-2)
                                            fetchData()
                                        }}
                                    >
                                        <Text style={styles.mainButtonText}>{languageFile.retry}</Text>
                                    </TouchableOpacity>
                                </View>
                            )
                    }
                })()}
            </View>
        </View>
    )
}

export const MyAdvanceScreen = ({ myAdvance, updateDate }: { myAdvance: MyAdvanceModel; updateDate: string }) => {
    const navigation = useNavigation()
    const onClickCertificate = (url: string) => {
        if (Platform.OS != 'web') {
            navigation.navigate('WebView', { link: url } as undefined)
        } else {
            Linking.openURL(url)
        }
    }
    const isMobile = useIsMobile()
    return (
        <View
            style={{
                flex: 1,
                backgroundColor: 'white',
                flexDirection: 'column',
                width: '100%',
            }}
        >
            <View
                style={[
                    {
                        flex: 1,
                        backgroundColor: 'white',
                        flexDirection: 'column',
                        width: '100%',
                    },
                    !isMobile && { maxWidth: 1024, alignSelf: 'center', flex: undefined, paddingHorizontal: 12 },
                ]}
            >
                <ScrollView showsVerticalScrollIndicator={false} nestedScrollEnabled={true} style={{ backgroundColor: 'white' }}>
                    <AdvanceSection myAdvance={myAdvance} />
                    {myAdvance?.my_achievements && myAdvance.my_achievements.length > 0 && (
                        <AchievementsSection
                            achievement={myAdvance.my_achievements[0]}
                            level={myAdvance.level}
                            name={myAdvance.name}
                            onClickCertificate={onClickCertificate}
                        />
                    )}
                    {myAdvance.my_exams && myAdvance.my_exams.length > 0 && (
                        <ExamsSection exams={myAdvance.my_exams} onClickCertificate={onClickCertificate} />
                    )}

                    {myAdvance.my_points && <PointsSection points={myAdvance.my_points} />}
                    <Text style={[styles.infoText, styles.alignCenter, { marginBottom: 16 }]}>{'Última actualización: ' + updateDate}</Text>
                </ScrollView>
            </View>
        </View>
    )
}
export const TitleWithDrawable = ({ title, containerStyle = null }: { title: string; containerStyle?: any }) => {
    const isMobile = useIsMobile()
    return (
        <View style={[styles.containerHeader, styles.marginHorizontal, { marginBottom: 8 }, containerStyle]}>
            <Ionicons name='trending-up-outline' size={20} color={theme.colors.textPrimary} />
            <Text style={[styles.section, styles.marginLeft, !isMobile && { fontSize: 16 }]}>{title}</Text>
        </View>
    )
}
export const AdvanceSection = ({ myAdvance }: { myAdvance: MyAdvanceModel }) => {
    const isMobile = useIsMobile()

    return (
        <View style={[{ backgroundColor: 'white', marginTop: 16 }]}>
            <TitleWithDrawable title='Mi avance' />
            <View style={[styles.containerSection, !isMobile && { borderRadius: 12 }]}>
                {myAdvance.avatar != '' ? (
                    <Image source={{ uri: myAdvance.avatar ?? avatarPlaceholder }} style={styles.avatar} />
                ) : (
                    <Image source={{ uri: avatarPlaceholder }} style={styles.avatar} />
                )}
                <View style={styles.marginHorizontal}>
                    {myAdvance.level && (
                        <Text style={[styles.titleSection, !isMobile && { fontSize: 16, transform: 'ca' }]}>
                            {isMobile ? myAdvance.level ?? '' : myAdvance.level.toUpperCase() ?? ''}
                        </Text>
                    )}
                    {myAdvance.name && <Text style={[styles.subtitleSection, !isMobile && { fontSize: 16 }]}>{myAdvance.name ?? ''}</Text>}
                    {myAdvance.role && (
                        <Text style={[styles.descriptionSection, !isMobile && { fontSize: 16 }]}>
                            {isMobile ? myAdvance.role ?? '' : myAdvance.role.capitalize()}
                        </Text>
                    )}
                </View>
            </View>
            {myAdvance.watched_content && <ViewedContent watchedContent={myAdvance.watched_content} />}
        </View>
    )
}

export const ViewedContent = ({ watchedContent }: { watchedContent: AdvanceWatchedContent }) => {
    const totalWatched = watchedContent.total ?? 0

    const getColor = (name: string) => {
        switch (name.toLowerCase()) {
            case 'índice salesbook':
                return theme.colors.colorPrimary
            case 'teórica':
                return theme.colors.colorInProgress
            case 'práctica':
                return theme.colors.colorApproved
            default:
                return theme.colors.textPrimary
        }
    }
    const isMobile = useIsMobile()
    const initialSize = 230
    const sizeDifference = 50
    if (totalWatched === 0) return <></>
    return (
        <View style={styles.containerProgress}>
            <View style={{ flex: 1 }}>
                <Text style={[styles.titleProgressBar, { marginBottom: 8, marginTop: 16 }, !isMobile && { fontSize: 16 }]}>Contenido visto</Text>
                <Progress.Bar
                    progress={totalWatched / 100}
                    height={isMobile ? 12 : 8}
                    width={null}
                    style={[styles.progressBar, { marginHorizontal: 0 }]}
                    color={colorFilled}
                    unfilledColor={theme.colors.lightGray}
                />

                {totalWatched > 0 ? (
                    <View style={{ flex: 1 }}>
                        {watchedContent.detail && watchedContent.detail.length > 0 && (
                            <View
                                style={[
                                    { flex: 1, alignItems: 'center' },
                                    !isMobile && {
                                        minHeight: initialSize + 40,
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                    },
                                ]} // En web no esta tomando el alto correctamente, por lo que se setea a mano
                            >
                                <View
                                    style={{
                                        height: initialSize,
                                        aspectRatio: 1,
                                        alignContent: 'center',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginVertical: 20,
                                    }}
                                >
                                    {watchedContent.detail.map((detail, index) => {
                                        let color = getColor(detail.name)

                                        let size = initialSize - index * sizeDifference
                                        let total = detail.total ?? 0

                                        return <CircularProgressView key={index} color={color} progress={total} size={size} />
                                    })}
                                    <Text style={styles.percentage}>{(watchedContent.indice_salesbook ?? 100) + '%'}</Text>
                                </View>
                                <View
                                    style={[
                                        styles.containerRow,
                                        { marginBottom: 15 },
                                        !isMobile && { flexDirection: 'column', marginStart: 12, gap: 8, marginBottom: 0, width: 'auto' },
                                    ]}
                                >
                                    {watchedContent.detail.map((detail, index) => {
                                        let color = getColor(detail.name)
                                        return (
                                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                <View style={[styles.reference, { backgroundColor: color }]}></View>
                                                <Text style={[styles.subtitleSection, !isMobile && { fontSize: 16 }]}>{detail.name}</Text>
                                            </View>
                                        )
                                    })}
                                </View>
                            </View>
                        )}
                    </View>
                ) : (
                    <View style={!isMobile && { alignSelf: 'flex-start', flexDirection: 'row', alignItems: 'center', marginVertical: 12 }}>
                        <Image
                            source={require('../../../assets/advance/noDataProgress.png')}
                            style={[styles.noDataProgress, { marginTop: 16, marginBottom: 8 }]}
                        />

                        <Text style={[styles.noDataText, { marginBottom: 4 }, !isMobile && { fontSize: 16, marginBottom: 0, paddingHorizontal: 16 }]}>
                            No hay datos suficientes para mostrar tus indicadores
                        </Text>
                    </View>
                )}
            </View>
        </View>
    )
}
const CircularProgressView = ({ progress, color, size }: { progress: number; color: string; size: number }) => {
    const isMobile = useIsMobile()
    return (
        <Progress.Circle
            size={size}
            progress={progress / 100}
            showsText={false}
            thickness={isMobile ? 10 : 8}
            color={color}
            unfilledColor={theme.colors.lightGray}
            borderWidth={0}
            borderColor={color}
            strokeCap='round'
            style={{ position: 'absolute', width: size, height: size, flex: 1 }}
        />
    )
}
export const AchievementsSection = ({
    achievement,
    level,
    name,
    onClickCertificate,
}: {
    achievement: AdvanceAchievement
    level: string
    name: string
    onClickCertificate: (url: string) => void
}) => {
    const isMobile = useIsMobile()
    return (
        <>
            <TitleWithDrawable title='Mis logros' containerStyle={!isMobile && { marginTop: 20 }} />
            <View style={[styles.containerSection, { marginBottom: 16 }, !isMobile && { borderRadius: 12 }]}>
                <Image source={require('../../../assets/advance/myAdvanceCup.png')} style={styles.avatar} />
                <View style={styles.marginHorizontal}>
                    <Text style={[styles.titleSection, { marginBottom: 2 }, !isMobile && { fontSize: 16 }]}>{level}</Text>
                    <Text style={[styles.subtitleSection, { marginBottom: 2 }, !isMobile && { fontSize: 16 }]}>{name}</Text>
                    {achievement.download_url && (
                        <TouchableOpacity style={styles.containerRow} onPress={() => onClickCertificate(achievement.download_url)}>
                            <Text style={styles.descriptionSection}>{'CERTIFICADO'}</Text>
                            <Ionicons name='eye' size={16} color={theme.colors.colorPrimary} style={styles.marginLeft} />
                        </TouchableOpacity>
                    )}
                </View>
            </View>
        </>
    )
}
const ColumnLayout = {
    curso: 5,
    intentos: 0.5,
    calificacion: 1,
}
export const ExamsSection = ({ exams, onClickCertificate }: { exams: AdvanceExam[]; onClickCertificate: (url: string) => void }) => {
    const isMobile = useIsMobile()
    return exams.length > 0 ? (
        <View style={{ paddingBottom: 20 }}>
            <TitleWithDrawable title='Exámenes' containerStyle={!isMobile && { marginTop: 20 }} />

            <View style={[styles.containerRow, styles.paddingHorizontal, { marginBottom: 4 }]}>
                <Text style={[styles.subtitleModule, { flex: 1 }, !isMobile && { fontSize: 16 }]}>CURSO</Text>
                <Text style={[styles.subtitleModule, { marginLeft: 12, minWidth: 50 }, !isMobile && { fontSize: 16 }]}>INT.</Text>
                <Text style={[styles.subtitleModule, { marginLeft: 12, minWidth: 70 }, !isMobile && { fontSize: 16 }]}>CALIF.</Text>
            </View>
            <FlashList
                data={exams}
                horizontal={false}
                keyExtractor={(item, index) => index.toString()}
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={{ borderRadius: isMobile ? 0 : 12, overflow: 'hidden' }}
                renderItem={({ item: benefitItem }) => <ExamItem exam={benefitItem} onClickCertificate={onClickCertificate} />}
            />
        </View>
    ) : (
        <View>
            <TitleWithDrawable title='Exámenes' />
            <Image source={require('../../../assets/advance/noDataEvaluations.png')} style={styles.noDataEvaluations} />

            <Text style={[styles.noDataText, { marginTop: 8, marginBottom: 16 }]}>No tienes resultados de evaluación</Text>
        </View>
    )
}
export const ExamItem = ({ exam, onClickCertificate }: { exam: AdvanceExam; onClickCertificate: (url: string) => void }) => {
    const score = () => {
        let value = exam.score ?? 0
        if (Number.isInteger(value)) return value
        return value.toFixed(1)
    }
    const isMobile = useIsMobile()

    return (
        <View style={styles.containerSection}>
            <View style={{ flex: 1, minWidth: 0 }}>
                <Text style={[styles.myExamsSection, !isMobile && { fontSize: 16, fontWeight: 'medium' }]} numberOfLines={2} ellipsizeMode='tail'>
                    {exam.name.capitalize()}
                </Text>

                {exam.download_url && (
                    <TouchableOpacity style={styles.containerRow} onPress={() => onClickCertificate(exam.download_url)}>
                        <Text style={styles.descriptionSection}>CERTIFICADO</Text>
                        <Ionicons name='eye' size={16} color={theme.colors.colorPrimary} style={styles.marginLeft} />
                    </TouchableOpacity>
                )}
            </View>

            <View style={[styles.containerDataSection, { flex: 0, minWidth: 50 }]}>
                <Text style={[styles.subtitleModule, !isMobile && { fontSize: 16 }]}>{exam.attempts ?? 0}</Text>
            </View>

            <View style={[styles.containerDataSection, { flex: 0, minWidth: 70 }]}>
                <Text
                    style={[
                        styles.subtitleModule,
                        { color: exam.approved ? theme.colors.colorApproved : theme.colors.colorDisapproved },
                        !isMobile && { fontSize: 16 },
                    ]}
                >
                    {score() + '%'}
                </Text>
            </View>
        </View>
    )
}

export const PointsSection = ({ points }: { points: AdvanceMyPoints }) => {
    const isMobile = useIsMobile()
    return (
        <>
            <TitleWithDrawable title='Mis puntos' />
            <View style={[styles.containerSection, !isMobile && { backgroundColor: 'white', gap: 16 }]}>
                {points.level && (
                    <View style={[styles.containerDataSection, !isMobile && { backgroundColor: theme.colors.filtersBackground, marginLeft: 0 }]}>
                        <Text style={[styles.myPointsSection, !isMobile && { fontSize: 16 }]}>Nivel</Text>
                        <Text style={[styles.descriptionSection, !isMobile && { fontSize: 16 }]}>{points.level ?? ''}</Text>
                    </View>
                )}

                {points.ranking && (
                    <View style={[styles.containerDataSection, !isMobile && { backgroundColor: theme.colors.filtersBackground, marginLeft: 0 }]}>
                        <Text style={[styles.myPointsSection, !isMobile && { fontSize: 16 }]}>Ranking</Text>
                        <Text style={[styles.descriptionSection, !isMobile && { fontSize: 16 }]}>{points.ranking ?? ''}°</Text>
                    </View>
                )}

                <View style={[styles.containerDataSection, !isMobile && { backgroundColor: theme.colors.filtersBackground, marginLeft: 0 }]}>
                    <Text style={[styles.myPointsSection, !isMobile && { fontSize: 16 }]}>Puntos</Text>
                    <Text style={[styles.descriptionSection, !isMobile && { fontSize: 16 }]}>{points.points ?? '0'}</Text>
                </View>
            </View>
        </>
    )
}
